// @ts-nocheck
function Mash() {
    let n = 0xefc8249d;

    const mash = function(data: any) {
        data = data.toString();
        for (let i = 0; i < data.length; i++) {
            n += data.charCodeAt(i);
            let h = 0.02519603282416938 * n;
            n = h >>> 0;
            h -= n;
            h *= n;
            n = h >>> 0;
            h -= n;
            n += h * 0x100000000; // 2^32
        }
        return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
    };

    mash.version = 'Mash 0.9';
    return mash;
}

// From http://baagoe.com/en/RandomMusings/javascript/
function Kybos() {
    return (function(args) {
        // Johannes BaagÃ¸e <baagoe@baagoe.com>, 2010
        let s0 = 0;
        let s1 = 0;
        let s2 = 0;
        let c = 1;
        const s = [];
        let k = 0;

        const mash = Mash();
        s0 = mash(' ');
        s1 = mash(' ');
        s2 = mash(' ');
        for (let j = 0; j < 8; j++) {
            s[j] = mash(' ');
        }

        if (args.length == 0) {
            args = [+new Date()];
        }
        for (let i = 0; i < args.length; i++) {
            s0 -= mash(args[i]);
            if (s0 < 0) {
                s0 += 1;
            }
            s1 -= mash(args[i]);
            if (s1 < 0) {
                s1 += 1;
            }
            s2 -= mash(args[i]);
            if (s2 < 0) {
                s2 += 1;
            }
            for (let j = 0; j < 8; j++) {
                s[j] -= mash(args[i]);
                if (s[j] < 0) {
                    s[j] += 1;
                }
            }
        }

        const random = function() {
            const a = 2091639;
            k = (s[k] * 8) | 0;
            const r = s[k];
            const t = a * s0 + c * 2.3283064365386963e-10; // 2^-32
            s0 = s1;
            s1 = s2;
            s2 = t - (c = t | 0);
            s[k] -= s2;
            if (s[k] < 0) {
                s[k] += 1;
            }
            return r;
        };
        random.uint32 = function() {
            return random() * 0x100000000; // 2^32
        };
        random.fract53 = function() {
            return random() + ((random() * 0x200000) | 0) * 1.1102230246251565e-16; // 2^-53
        };
        random.addNoise = function() {
            for (let i = arguments.length - 1; i >= 0; i--) {
                for (j = 0; j < 8; j++) {
                    // eslint-disable-next-line prefer-rest-params
                    s[j] -= mash(arguments[i]);
                    if (s[j] < 0) {
                        s[j] += 1;
                    }
                }
            }
        };
        random.version = 'Kybos 0.9';
        random.args = args;
        return random;
        // eslint-disable-next-line prefer-rest-params
    })(Array.prototype.slice.call(arguments));
}

const rnd = Kybos();

// UUID/GUID implementation from http://frugalcoder.us/post/2012/01/13/javascript-guid-uuid-generator.aspx
const UUID = {
    empty: '00000000-0000-0000-0000-000000000000',
    parse: function(input) {
        const ret = input
            .toString()
            .trim()
            .toLowerCase()
            .replace(/^[\s\r\n]+|[\{\}]|[\s\r\n]+$/g, '');
        if (/[a-f0-9]{8}\-[a-f0-9]{4}\-[a-f0-9]{4}\-[a-f0-9]{4}\-[a-f0-9]{12}/.test(ret)) return ret;
        else throw new Error('Unable to parse UUID');
    },
    createSequential: function() {
        let ret = new Date()
            .valueOf()
            .toString(16)
            .replace('-', '');
        for (; ret.length < 12; ret = '0' + ret);
        ret = ret.substr(ret.length - 12, 12); //only least significant part
        for (; ret.length < 32; ret += Math.floor(rnd() * 0xffffffff).toString(16));
        return [
            ret.substr(0, 8),
            ret.substr(8, 4),
            '4' + ret.substr(12, 3),
            '89AB'[Math.floor(Math.random() * 4)] + ret.substr(16, 3),
            ret.substr(20, 12),
        ].join('-');
    },
    create: function() {
        let ret = '';
        for (; ret.length < 32; ret += Math.floor(rnd() * 0xffffffff).toString(16));
        return [
            ret.substr(0, 8),
            ret.substr(8, 4),
            '4' + ret.substr(12, 3),
            '89AB'[Math.floor(Math.random() * 4)] + ret.substr(16, 3),
            ret.substr(20, 12),
        ].join('-');
    },
    random: function() {
        return rnd();
    },
    tryParse: function(input) {
        try {
            return UUID.parse(input);
        } catch (ex) {
            return UUID.empty;
        }
    },
};

export { UUID };
